import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function Badge({ children }:Props) {
    return (
        <Wrapper aria-label='badge' >
            <BadgeText fontWeight='medium'
                color={colors.gray6}>
                {children}
            </BadgeText>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: var(--color-gray2);
    border-radius: 6px;
    padding: 4px;
    white-space: nowrap;
`;

const BadgeText = styled(Text)`
    font-size: 10px;
    line-height: 1;
`;

export default Badge;
